import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { BaseOptionType, DefaultOptionType } from 'antd/lib/select';
import { Button, Divider, Select as AntdSelect, SelectProps } from 'antd';

export interface FMGSelectProps extends SelectProps<any, BaseOptionType | DefaultOptionType> {
  showAdd?: boolean;
  onAdd?: () => void;
}

export const Select = ({ showAdd = false, onAdd, dropdownRender, ...props }: FMGSelectProps) => {
  const defaultDropdownRender = (menu: React.ReactElement) => (
    <>
      {menu}
      {showAdd && (
        <>
          <Divider />
          <div style={{ display: 'flex', justifyContent: 'center', padding: 8 }}>
            <Button type="link" style={{ color: '#05796B', margin: 0 }} icon={<PlusOutlined />} onClick={onAdd}>
              Add New
            </Button>
          </div>
        </>
      )}
      {dropdownRender && dropdownRender(menu)}
    </>
  );

  return (
    <AntdSelect
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
      dropdownRender={defaultDropdownRender}
      {...props}
    />
  );
};

// Add Option back for usage like in Ant Design
Select.Option = AntdSelect.Option;
